import React from 'react';

const AbstractIcon = (props: any) => {
  const { strokeColor = '#000000' } = props;
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='1.5rem' height='3rem' viewBox='0 0 26 27' fill='none'>
      <path
        d='M11.0783 24.7203L10.7099 25.8755H11.9225H15.7109H16.3616L16.5563 25.2546L18.2396 19.8853H21.6039H22.49V18.9993V15.5994V14.7134H21.6039H19.8631L20.6361 12.2437H23.9353H24.8213V11.3577V7.95784V7.07182H23.9353H22.2618L23.7765 2.26637L24.1398 1.11398H22.9315H19.1107H18.4576L18.2644 1.73782L16.612 7.07182H13.8755L15.3902 2.26637L15.7535 1.11398H14.5452H10.692H10.0355L9.8444 1.74202L8.22229 7.07182H4.86371H3.97769V7.95784V11.3577V12.2437H4.86371H6.58092L5.82682 14.7134H2.5H1.61398V15.5994V18.9993V19.8853H2.5H4.20783L2.6907 24.7244L2.32982 25.8755H3.53615H7.32456H7.97532L8.17 25.2546L9.85334 19.8853H12.6203L11.0783 24.7203ZM14.9759 12.2437L14.2407 14.7134H11.4768L12.2498 12.2437H14.9759Z'
        fill={strokeColor}
        stroke='black'
        strokeWidth='1.77205'
      />
    </svg>
  );
};

export default AbstractIcon;
